export const CHAPTER_TEST_FILTER = [
  { label: '학습지 종류 전체', value: 'ALL' },
  { label: '단원 테스트', value: 'CHAPTER_TEST' },
  { label: '총괄 테스트', value: 'GENERAL_TEST' },
] as const

export const LEVEL_LABELS = [
  { value: '1', label: '하' },
  { value: '2', label: '중하' },
  { value: '3', label: '중' },
  { value: '4', label: '상' },
  { value: '5', label: '최상' },
]
